import AdminApi from '../services/api';
import swal from 'sweetalert2';
import session from "../services/session";
import Loc from "../services/localization";

/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default{

    props: ['show', 'date', 'type', 'data', 'programId'],

    data() {
        return {
            locale: LocService,
            isLoading: false,
            title: '',
            users: [],
            hasError: '',
            currentDate: '',
            filter: '',
            trainings: [],
            selectedImage: null,
            selectedImagePreview: null,
            imageUrl: null,
            showChooseButton: true,
            dataToEdit: null,
            personalProgramId: 0,

            categories: [],
            showAddCategory: false,
            newCategory: '',
            selectedCategory: "null",
            isLoadingCategory: false,

            trainingMeasures: [],
            showAddMeasures: false,
            newMeasure: '',
            selectedMeasure: "null",
            isLoadingMeasure: false,

            model: {
                type: '',
                date: '',
                trainingDefinition: {
                    type: '',
                    name: '',
                    enName: '',
                    imageUrl: '',
                    videoUrl: '',
                    superSetId: '',
                    superSetName: '',
                    shortDescription: '',
                    enShortDescription: '',
                    longDescription: '',
                    enLongDescription: '',
                    category: null,
                    resultMeasure: null,
                    resultRounds: null
                }
            },
            selectedLanguageIndex: 0,
            languages: [
                {
                    id: 'sr',
                    name: 'Srpski',
                },
                {
                    id: 'en',
                    name: 'English',
                },
            ],
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val){
                this.personalProgramId = this.programId;
                this.model.type = this.type;
                this.model.date = this.date;
                this.currentDate = this.date;
                this.dataToEdit = this.data;
                this.title = this.dataToEdit == null ? LocService.t('label_add_td') : LocService.t('label_edit_td')
                this.model.trainingDefinition.type = this.type;
                this.showChooseButton = this.dataToEdit == null
                if(this.dataToEdit != null){
                    this.model.id =  this.dataToEdit.id
                    this.model.trainingDefinition.id = this.dataToEdit.definitionId
                    this.model.trainingDefinition.videoUrl = this.dataToEdit.videoUrl
                    this.model.trainingDefinition.imageUrl = this.dataToEdit.imageUrl
                    this.model.imageUrl = this.dataToEdit.imageUrl
                    this.imageUrl = this.dataToEdit.imageUrl
                    this.model.trainingDefinition.superSetId =
                        this.dataToEdit.superSetId != null
                            ? this.dataToEdit.superSetId
                            : (this.dataToEdit.trainingDefinition != null && this.dataToEdit.trainingDefinition.superSetId != null
                                ? this.dataToEdit.trainingDefinition.superSetId
                                : '')
                    this.model.trainingDefinition.superSetName =
                        this.dataToEdit.superSetName != null
                            ? this.dataToEdit.superSetName
                            : (this.dataToEdit.trainingDefinition != null && this.dataToEdit.trainingDefinition.superSetName != null
                                ? this.dataToEdit.trainingDefinition.superSetName
                                : '')
                    this.model.trainingDefinition.name = this.dataToEdit.name
                    this.model.trainingDefinition.enName = this.dataToEdit.enName
                    this.model.trainingDefinition.shortDescription = this.dataToEdit.shortDescription
                    this.model.trainingDefinition.enShortDescription = this.dataToEdit.enShortDescription
                    this.model.trainingDefinition.longDescription = this.dataToEdit.longDescription
                    this.model.trainingDefinition.enLongDescription = this.dataToEdit.enLongDescription
                    this.model.trainingDefinition.category = this.dataToEdit.category
                    this.model.trainingDefinition.resultRounds = this.dataToEdit.resultRounds
                    this.model.trainingDefinition.resultMeasure = this.dataToEdit.resultMeasure
                }
                this.getAllCategories( true)
                this.getAllMeasures( true)
            }
        },
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeTrainingDefinition')
            this.reset();
            this.trainings = []
            this.currentDate = ''
            this.startAtTime = ''
        },
        keymonitor: keymonitor,
        reset: reset,
        uploadPhotoBeforeApi: uploadPhotoBeforeApi,
        loadTextFromFile: loadTextFromFile,
        handlePasteVideo: handlePasteVideo,
        chooseExist: chooseExist,
        getAllCategories: getAllCategories,
        deleteCategory: deleteCategory,
        getAllMeasures: getAllMeasures,
        addTypeCategory: addTypeCategory,
        addMeasure: addMeasure,
        deleteMeasure: deleteMeasure,
        addTraining: addTraining,
        editTraining: editTraining,
        isSelectedLanguage: isSelectedLanguage,
        getChipClassLanguage: getChipClassLanguage,
        onSelectedLanguage: onSelectedLanguage,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small modal--training-editor'
            }else {
                return 'modal--large modal--training-editor'
            }
        },
        preventClose() {
            // Prazna funkcija koja blokira zatvaranje na klik izvan modala
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: #1C242D;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            if(this.isMobile()){
                return 'background-color: #1C242D; color: #ffffff;'
            }else {
                return 'background-color: #1C242D; color: #ffffff;'
            }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'height: auto !important; overflow: visible;';
            }
            return 'height: auto !important; overflow: visible;';
        }

    }
}

function addMeasure(){
    let _self = this;
    let model = {
        name: _self.newMeasure,
        type: "MEASURE"
    }
    if(model.name.length === 0) return;
    _self.isLoadingMeasure = true
    AdminApiService.addTrainingDefinitionTypeCategory(model)
        .then((response) => {
            _self.getAllMeasures(false);
            _self.newMeasure = ""
        })
        .catch((error) => {
            _self.isLoadingMeasure = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function getAllMeasures(firstTime){
    let _self = this;
    AdminApiService.getTrainingDefinitionTypeCategory("MEASURE")
        .then((response) => {
            _self.trainingMeasures = response.data
            _self.isLoadingMeasure = false
            _self.showAddMeasures = false;
            if(firstTime){
                var filtered = _self.trainingMeasures.filter(c => c.name === _self.model.trainingDefinition.resultMeasure)
                if(filtered.length > 0){
                    _self.selectedMeasure = filtered[0]
                }
            }
        })
        .catch((error) => {
            this.isLoading = false;
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function deleteMeasure(){
    let _self = this;
    if(this.selectedMeasure == null) return;
    _self.isLoadingMeasure = true
    AdminApiService.deleteTrainingDefinitionTypeCategory(this.selectedMeasure.id)
        .then((response) => {
            _self.getAllMeasures(false);
            _self.selectedMeasure = "null"

        })
        .catch((error) => {
            _self.isLoadingMeasure = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function handlePasteVideo(event){
    event.preventDefault();
    const pasteText = (event.clipboardData || window.clipboardData).getData("text");
    // YouTube regularni izraz za standardne video linkove
    const videoIdRegex = /(?:https:\/\/www\.youtube\.com\/watch\?v=|https:\/\/youtu\.be\/|embed\/)([a-zA-Z0-9_-]{11})/;
    const match = pasteText.match(videoIdRegex);
    if (match) {
        this.model.trainingDefinition.videoUrl = `https://www.youtube.com/embed/${match[1]}`;
    } else {
        // Regex za YouTube Shorts
        const shortsRegex =
            /(?:https?:\/\/)?(?:www\.)?youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})(?:\?.*)?$/;
        const matchShorts = pasteText.match(shortsRegex);
        if (matchShorts) {
            this.model.trainingDefinition.videoUrl = `https://www.youtube.com/embed/${matchShorts[1]}`;
            return;
        }

        // Regex za Vimeo embed
        const iframeRegex = /<iframe.*?src="https:\/\/player\.vimeo\.com\/video\/(\d+).*?".*<\/iframe>/;
        const matchIframe = pasteText.match(iframeRegex);
        if (matchIframe) {
            this.model.trainingDefinition.videoUrl = `https://player.vimeo.com/video/${matchIframe[1]}`;
            return
        }

        // Regex za Vimeo link
        const vimeoLinkRegex = /https:\/\/vimeo\.com\/(\d+)/;
        const matchLink = pasteText.match(vimeoLinkRegex);

        if (matchLink) {
            this.model.trainingDefinition.videoUrl = `https://player.vimeo.com/video/${matchLink[1]}`;
            return;
        }

        this.model.trainingDefinition.videoUrl = pasteText;
    }
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        // this.load();
    }
}

function chooseExist(){
    this.$topnavbar.$emit('chooseExistTraining',this.currentDate)
}

function reset(){
    this.dataToEdit = null
    this.showChooseButton = true;
    this.selectedImage= null;
    this.selectedImagePreview= null;
    this.imageUrl= null;
    this.isLoading = false;
    this.personalProgramId = 0;
    this.selectedLanguageIndex = 0;
    this.selectedCategory= "null";
    this.selectedMeasure= "null";
    this.model = {
        type: '',
        date: '',
        trainingDefinition: {
            type: '',
            name: '',
            enName: '',
            imageUrl: '',
            videoUrl: '',
            superSetId: '',
            superSetName: '',
            shortDescription: '',
            enShortDescription: '',
            longDescription: '',
            enLongDescription: '',
            category: '',
            resultRounds: null,
            resultMeasure: null
        }
    }
}


function addTraining(url) {
    let _self = this;
    this.model.imageUrl = url;
    this.model.personalProgramId = this.personalProgramId;
    this.model.trainingDefinition.imageUrl = url;
    if(this.model.trainingDefinition.name == null ||
        this.model.trainingDefinition.name.length === 0){
        swal(LocService.t("label_error"), LocService.t('label_td_name_required'), 'warning')
        return;
    }
    this.model.trainingDefinition.category = this.selectedCategory != null ? this.selectedCategory.name : null;
    this.model.trainingDefinition.resultMeasure = this.selectedMeasure != null ? this.selectedMeasure.name : null;
    if(this.model.trainingDefinition.superSetName == null || this.model.trainingDefinition.superSetName.trim().length === 0){
        this.model.trainingDefinition.superSetName = 'SuperSet';
    }
    if(this.dataToEdit != null){
        this.editTraining();
        return;
    }
    AdminApiService.addNewTrainingOfTheDay(this.model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t('label_success_added_training_of_the_day'), 'success')
            _self.$topnavbar.$emit('successTrainingDefinition')
            _self.reset();
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function editTraining() {
    let _self = this;
    AdminApiService.editTrainingOfTheDay(this.model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t('label_success_edited_training_of_the_day'), 'success')
            _self.$topnavbar.$emit('successTrainingDefinition')
            _self.reset();
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function loadTextFromFile(ev) {
    var i = 0;
    for (i = 0; i < ev.target.files.length; i++) {
        const file = ev.target.files[i];
        if (file.size > 5000000) {
            alert(this.locale.t('label_max_size_picture'))
            return
        }
        const reader = new FileReader();
        this.selectedImage = file;
        this.selectedImagePreview = URL.createObjectURL(file);
        reader.onload = e => {
            // console.log(e.target.result);
            // _self.files.push(e.target.result);
        }

        reader.readAsDataURL(file);

    }
}

function uploadPhotoBeforeApi() {
    this.isLoading = true;
    let _self = this;
    if(this.selectedImage == null){
        _self.addTraining(this.imageUrl);
        return
    }
    AdminApiService.uploadImageTrainingOfTheDay(this.selectedImage)
        .then((response) => {
            _self.addTraining(response.data.url);
        })
        .catch((error) => {
            this.isLoading = false;
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function isSelectedLanguage(item, index){
    return this.selectedLanguageIndex === index
}

function getChipClassLanguage(item, index) {
    if (this.selectedLanguageIndex === index) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function onSelectedLanguage(item, index){
    this.selectedLanguageIndex = index
}


function getAllCategories(firstTime){
    let _self = this;
    AdminApiService.getTrainingDefinitionTypeCategory("CATEGORY")
        .then((response) => {
            _self.categories = response.data
            _self.isLoadingCategory = false
            _self.showAddCategory = false;
            if(firstTime){
                var filtered = _self.categories.filter(c => c.name === _self.model.trainingDefinition.category)
                if(filtered.length > 0){
                    _self.selectedCategory = filtered[0]
                }
            }
        })
        .catch((error) => {
            this.isLoading = false;
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function addTypeCategory(){
    let _self = this;
    let model = {
        name: _self.newCategory,
        type: "CATEGORY"
    }
    if(model.name.length === 0) return;
    _self.isLoadingCategory = true
    AdminApiService.addTrainingDefinitionTypeCategory(model)
        .then((response) => {
            _self.getAllCategories(false);
            _self.newCategory = ""
        })
        .catch((error) => {
            _self.isLoadingCategory = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function deleteCategory(){
    let _self = this;
    console.log(this.selectedCategory);
    if(this.selectedCategory == null) return;
    _self.isLoadingCategory = true
    AdminApiService.deleteTrainingDefinitionTypeCategory(this.selectedCategory.id)
        .then((response) => {
            _self.getAllCategories(false);
            _self.selectedCategory = "null"

        })
        .catch((error) => {
            _self.isLoadingCategory = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}



// WEBPACK FOOTER //
// ./src/modals/AddTrainingOfTheDayPersonal.js